module.exports = __webpack_public_path__ + "img/grumpy.png?9a77876fbdf19bac87a1572101cfe566";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grumpy.png
// module id = 1260
// module chunks = 1